import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
  FaPlus,
  FaMinus,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import { Container, ContainerWhite } from './styles';
import Input from '../../components/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';

import { Pattern } from '../../styles/ThemeComponents';
import ShowDiv from '../../components/ShowOnScroll';
import VideoBackground from '../../components/VideoBackground';
import TextPopper from '../../components/TextPopper';
import Scroller from '../../components/Scroller';

import Vimeo from '../../components/Vimeo';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Sobre: React.FC = () => {
  const [active, setActive] = useState(false);
  return (
    <>
      <ContainerWhite id="sobre">
        <div className="p50 p600">
          <h2 style={{ marginBottom: '10px' }}>Apresentação</h2>
          <p>
            Visando oferecer informações de qualidade sobre genética e carne
            premium, a Associação Brasileira de Angus promoverá a 3ª Jornada
            Técnica Angus. Com foco em criadores da raça, selecionadores,
            produtores rurais, técnicos e profissionais envolvidos o evento
            ocorrerá nos dias 24, 25 e 26 de novembro de forma virtual, em
            função da pandemia. Nas edições anteriores, realizadas em 2015 e em
            2017, foram debatidos assuntos como novas tecnologias voltadas à
            nutrição de animais, melhoramento genético, integração
            lavoura-pecuária e controle de carrapato.
            <br />
            <br />
            A programação contará com painéis sobre avanços da genômica,
            cruzamento industrial e mercado de carnes, perspectivas e tendências
            de consumo de produtos premium, que são pilares fomentados pela
            Angus através de diversos projetos em busca do melhoramento genético
            dos rebanhos brasileiros. O americano Stephen Miller, que é diretor
            da Genetic Research of Angus Genetics Inc (AGI), está entre os
            palestrantes. Além dele, outros painelistas compõem a lista de
            renomados especialistas que participarão do evento.
            <br />
            <br />
{' '}
          </p>

          <div className={!active ? 'elastic active' : 'elastic notActive'}>
            <p style={{ textAlign: 'justify' }}>
              Com o objetivo de tirar as dúvidas dos participantes, ao final de
              cada dia haverá espaço para debates. A programação contará ainda
              com a divulgação do vencedor do Mérito Genético Angus 2020.
              <br />
              <br />
              A Jornada deste ano será realizada de forma totalmente virtual
              devido à pandemia. Apesar da mudança, a ideia é que haja o mesmo
              dinamismo e engajamento das edições realizadas presencialmente,
              mantendo uma programação com painéis comandados por palestrantes
              de excelência.
              <br />
              <br />
              Durante o evento, serão apresentados ainda alguns dos trabalhados
              realizados pela Angus ao longo de 2020, como a parceria com a
              Empresa Brasileira de Pesquisa Agropecuária (Embrapa) para
              pesquisa genômica nos rebanhos brasileiros. Mesmo com os desafios
              ocasionados com a chegada da Covid-19, a Associação manteve suas
              atividades, tomando os cuidados necessários, para garantir que os
              criadores tivessem informações em mãos e os consumidores uma carne
              de qualidade em suas mesas.
            </p>
          </div>
          <button
            onClick={() => setActive(!active)}
            className="ball"
            type="button"
          >
            {' '}
            {active ? <FaMinus /> : <FaPlus />}
{' '}
          </button>
        </div>
      </ContainerWhite>
    </>
  );
};
export default Sobre;
